import BenchlingConfig from 'BenchlingConfig';

/** Returns how many chips should be displayed, depending on if we're in Export (print) view */
export default function getMaxChipsToDisplay(
  defaultNumber: number,
  isExportView: boolean
): number | undefined {
  if (isExportView) {
    const configMax = BenchlingConfig.ELN_EXPORT_PDF_CONFIG.maxChipsInTables;
    if (configMax != null) {
      // if we configured to be 0, then provide no max
      if (configMax === 0) {
        return undefined;
      }
      return configMax;
    }
  }
  return defaultNumber;
}
